module.exports = __webpack_public_path__ + "src/assets/img/s-message.812e671d.svg";